import { render, staticRenderFns } from "./EditLab.vue?vue&type=template&id=98f25d54&"
import script from "./EditLab.vue?vue&type=script&lang=js&"
export * from "./EditLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports